<template>
  <b-modal
    title="Busqueda por criterios"
    id="information"
    v-model="show"
    size="xl"
    no-close-on-backdrop
    scrollable
    :header-bg-variant="dark ? 'dark' : 'light'"
    :header-text-variant="dark ? 'light' : 'dark'"
    :body-bg-variant="dark ? 'dark' : 'light'"
    :body-text-variant="dark ? 'light' : 'dark'"
    :footer-bg-variant="dark ? 'dark' : 'light'"
    :footer-text-variant="dark ? 'light' : 'dark'"
  >
    <b-card :class="[dark ? 'dark-mode-page' : '']" >
      <form :key="nKeyForm" @submit.prevent="onSearch()">
        <b-row>
          <b-col md="6">
            <label :class="[dark ? 'text-white': '']"  >seleccione el criterio</label>
            <div
              class="checkbox-list"
              v-for="(item, idx) in statusList"
              :key="idx"
            >
              <label :class="`checkbox ${item.class}`">
                <input
                  type="checkbox"
                  name="Checkboxes1"
                  :value="item.id"
                  v-model="oForm.criterio"
                />
                <span></span> {{ item.text }}</label
              >
            </div>
          </b-col>
          <b-col md="6">
            <div class="input-group">
              <input
                required
                type="text"
                class="form-control"
                v-model="oForm.busqueda"
                placeholder="entrada"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div
            class="mt-5 col-12 input-group-append d-flex flex-row justify-content-center"
          >
            <button class="btn btn-primary btn-lg" type="submit" :disabled="isLoading">
              <!-- :disabled="loading" -->
              {{ isLoading ? "Cargando..." : "Consultar"}}
            </button>
          </div>
        </b-row>
        <b-row v-if="aOptions.length > 1" >
          <b-col md="6">
            <label :class="[dark ? 'text-white': '']"  >Opciones encontradas</label>
            <div
              class="checkbox-list"
              v-for="(item, idx) in aOptions"
              :key="idx"
            >
              <label :class="`checkbox ${item.class}`">
                <input
                  :key="item.id"
                  type="checkbox"
                  name="Checkboxes1"
                  :value="item.id"
                  @change="changeCircuit"
                  v-model="aCircuit"
                />
                <span></span> {{ item.text }}
              </label>
            </div>
          </b-col>
          <b-col md="6" class="d-flex justify-content-start align-items-center">
            <button   
              @click="onConfirChoice" 
              class="btn btn-primary btn-sm"
              :disabled="aCircuit.length == 0 || isLoading"
            >
              {{isLoading ? "Cargando circuito..." : "Confirmar circuito"}}
            </button>
          </b-col>  
        </b-row>
      </form>
    </b-card>

    <template #modal-footer>
      <button @click="() => (show = false)" class="btn btn-sm btn-link">
        <i class="flaticon-close"></i> Cerrar
      </button>
      <!-- <button class="btn btn-primary btn-sm ml-2" @click="reabrirCaso()">
        <i class="la la-save"></i>
        {{ loading ? "Cargando..." : "Guardar" }}
      </button> -->
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      show: false,
      nKeyForm: 0,
      oForm: {
        criterio: [],
        busqueda: "",
      },
      statusList: [
        {
          id: "nombre_circuito",
          text: "Nombre del circuito",
          class: "checkbox-primary",
        },
        {
          id: "elemento",
          text: "Codigo del elemento",
          class: "checkbox-info",
        },
        {
          id: "matricula",
          text: "Matricula del elemento",
          class: "checkbox-success",
        },
        // {
        //   id: 5,
        //   text: "Ejecutadas",
        //   class: "checkbox-success",
        // },
        // {
        //   id: 6,
        //   text: "Certificadas",
        //   class: "checkbox-warning",
        // },
        // {
        //   id: 8,
        //   text: "Rechazadas",
        //   class: "checkbox-danger",
        // },
      ],
      aCircuit: [],
      aOptions: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      dark: "mode/getTheme",
    }),
  },
  methods: {
    onSearch() {
      if (this.oForm.criterio.length > 1) {
        this.$swal.fire({
          title: "Solo se puede buscar por un criterio a la vez",
          icon: "warning",
          confirmButtonText: "Ok, entiendo",
        });
        return;
      }
      this.$emit("onForm", {
        criterio: this.oForm.criterio[0],
        busqueda: this.oForm.busqueda,
      });
      // this.clearForm();
    },
    clearForm() {
      this.oForm = {
        criterio: [],
        busqueda: "",
      };
    },
    changeCircuit({target}){
      const value = Number(target.value);
      this.aCircuit = [value];
    },
    onConfirChoice(){
      if (this.aCircuit.length > 1) {
        this.$swal.fire({
          title: "Solo se puede seleccionar mas de un circuito",
          icon: "warning",
          confirmButtonText: "Ok, entiendo",
        });
        return;
      }

      if (this.aCircuit.length === 1) {
        this.$emit("onSelectCircuit", this.aCircuit[0]);
      }
    },
  },
};
</script>
